import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import React from 'react'
import type { Customer } from '@ztechapps/common.contract'
import merge from 'lodash/merge'
import { MemberWithInfoItem } from './MemberWithInfoItem'
import { Col } from 'react-bootstrap'

type Components = {
  memberWithInfoItem: FunctionComponent
}

const defaultComponents = {
  memberWithInfoItem: MemberWithInfoItem,
}

export type MembersWithInfoInlineInputDisplayContentProps = {
  value: Customer[]
  buildLinkTo: ({ _id }: { _id: string }) => string
  components: Components
}
export const MembersWithInfoInlineInputDisplayContent = ({ value, buildLinkTo, components }: MembersWithInfoInlineInputDisplayContentProps) => {
  components = merge({}, defaultComponents, components)

  return (
    <>
      {map(value, (m) => {
        const linkTo = buildLinkTo({ _id: m._id })
        return (
          <Col className="align-items-start" key={m?._id}>
            {components.memberWithInfoItem({ ...{ ...m, linkTo } })}
          </Col>
        )
      })}
    </>
  )
}
